import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { PostClosingDashboardStore } from '../stores/postClosingStore';

export const usePostClosingDashboardStore = () =>
  useContext<{
    postClosingDashboardStore: PostClosingDashboardStore;
  }>(StoreContext);